import axios from 'axios'
import { pathOr } from 'ramda'

import {
  DELETE_PROMO_CODE_INIT,
  DELETE_PROMO_CODE_SUCCESS,
  DELETE_PROMO_CODE_FAILED,
} from '../constants'
import {GLOBAL_ERROR_POPUP} from 'js/components/PopupConstructor/constants'
import openPopup from 'js/components/PopupConstructor/actions/popupActions'

const promoCodeRemoveUlr = window.drupalSettings?.search?.api?.promoCodeRemove;

const deletePromoCode = promoCode => async (dispatch) => {
  dispatch({ type: DELETE_PROMO_CODE_INIT })

  try {
    await axios.delete(`${promoCodeRemoveUlr}/${promoCode}`)
    return dispatch({
      type: DELETE_PROMO_CODE_SUCCESS,
    })
  } catch (e) {
    const data = pathOr({}, ['response', 'data'], e)
    dispatch({ type: DELETE_PROMO_CODE_FAILED, error: e.message, code: e.toString() })
    if (data.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, {
        ...data,
        onCloseFunc: (close) => {
          close()
          data.url_redirect ? window.location.replace(data.url_redirect) : null
        },
      }))
    }

    throw data
  }
}

export default deletePromoCode;
